import { render, staticRenderFns } from "./seguridad.vue?vue&type=template&id=e7cf37e6"
import script from "./seguridad.vue?vue&type=script&lang=js"
export * from "./seguridad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports